import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

function XmesiYcorrieri({ data, titolo, displayTitolo, settings }) {
  let dataset = [];
  let keyToLabel = {};

  if (settings.series.brt) {
    keyToLabel.brt_dpd = "BRT";
  }

  if (settings.series.gls) {
    keyToLabel.gls = "GLS";
  }

  if (settings.series.dhl) {
    keyToLabel.dhl = "DHL";
  }

  if (settings.series.ups) {
    keyToLabel.ups = "UPS";
  }

  if (settings.series.others) {
    keyToLabel.other = "ALTRO";
  }

  if (data.dataSet) {
    dataset = data.dataSet;
  }
  console.log("dataset", dataset);

  const colors = {
    brt_dpd: "#FF4136",
    gls: "#0e1e6e",
    dhl: "#FFB700",
    ups: "#5C3419",
    other: "grey",
  };

  const xData = dataset.map((row) => new Date(row.year_month_combined));

  const customize = {
    height: 700,
    margin: { top: 5 },
    stackingOrder: "descending",
    xAxis: [
      {
        data: xData,
        scaleType: "time",
        valueFormatter: (v) =>
          v.toLocaleString("it-IT", {
            year: "2-digit",
            month: "2-digit",
          }),
      },
    ],
  };

  const stackStrategy = {
    stack: "total",
    area: true,
    stackOffset: "none", // To stack 0 on top of others
    stackOrder: "reverse",
  };

  const series = Object.keys(keyToLabel).map((key) => ({
    dataKey: key,
    label: keyToLabel[key],
    color: colors[key],
    showMark: false,
    ...stackStrategy,
  }));

  console.log("series", series);

  if (data) {
    return (
      <div>
        {titolo && displayTitolo && (
          <div className="tc sfondoColChiaro pa2 b">{titolo}</div>
        )}
        {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
        <div className="pa2 flex flex-wrap items-center">
          <LineChart series={series} dataset={dataset} {...customize} />
        </div>
      </div>
    );
  } else {
    return <div>no data</div>;
  }
}

export default XmesiYcorrieri;
